const sortDescending = (a: string, b: string): number => {
  if (a > b) {
    return -1;
  }
  if (a < b) {
    return 1;
  }
  return 0;
};

const sortAscending = (a: string, b: string): number => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

const sortAlphabetical = (a: string, b: string, order?: string): number => {
  if (order === 'descending') {
    return sortDescending(a, b);
  }
  return sortAscending(a, b);
};

export default sortAlphabetical;
